export class ApiClientError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly details: unknown = null,
  ) {
    super(message);
  }
}

async function request<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, {
    credentials: "same-origin",
    ...init,
    headers: {
      ...(init?.body ? { "Content-Type": "application/json" } : {}),
      ...init?.headers,
    },
  });
  const contentType = response.headers.get("content-type") || "";
  const body = contentType.includes("application/json") ? await response.json() : await response.text();
  if (!response.ok) {
    const message = typeof body === "object" && body && "error" in body
      ? String((body as { error: unknown }).error)
      : "通信に失敗しました。";
    const details = typeof body === "object" && body ? body : null;
    throw new ApiClientError(message, response.status, details);
  }
  return body as T;
}

export const api = {
  get: <T>(url: string) => request<T>(url),
  post: <T>(url: string, body?: unknown) => request<T>(url, {
    method: "POST",
    body: body === undefined ? undefined : JSON.stringify(body),
  }),
  put: <T>(url: string, body: unknown) => request<T>(url, {
    method: "PUT",
    body: JSON.stringify(body),
  }),
};
